import React from 'react';
import styled from 'styled-components';
import { formTextBorderStyles, useFormTextStateProps, } from '../context';
const StyledTextInputWrapper = styled.span `
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
`;
const StyledFormTextBorder = styled.div `
  ${formTextBorderStyles}
`;
export const FormTextWrapper = React.forwardRef(({ children }, ref) => {
    const formTextStateProps = useFormTextStateProps({});
    return (React.createElement(StyledTextInputWrapper, { ref: ref, "data-testid": "mui-form-text-wrapper" },
        children,
        React.createElement(StyledFormTextBorder, Object.assign({}, formTextStateProps))));
});
//# sourceMappingURL=FormTextWrapper.js.map